"use strict";
function emailValidator(required, maxlength) {
    return function (control) {
        var noEmail = control.get('noEmail');
        var email = control.get('email');
        if (required && (email && !email.value) && (noEmail && !noEmail.value)) {
            return { 'required': true };
        }
        if (email && email.value) {
            var pattern = /^\S+@\S+\.\S+$/;
            if (!pattern.test(email.value)) {
                return { 'invalid': true };
            }
            if (maxlength && email.value.length > maxlength) {
                return { 'maxlength': true };
            }
        }
        return null;
    };
}
exports.emailValidator = emailValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/email.validator.js